import type { AutoString } from 'types/utils';
import { z } from 'zod/v4';

export const validations = {
  required: 'validation|required.field',
  email: 'validation|invalid.email',
  privacy: 'validation|accept.policy',
  string: 'validation|string',
} as const;

export type ValidationString = AutoString<(typeof validations)[keyof typeof validations]>;

export const emailSchema = z.email({ error: validations.email }).refine(
  (input) => {
    if (typeof input !== 'string') return false;
    return ![
      '@gnail.com',
      '@gmail.con',
      '@hotnail.com',
      '@gmial.com',
      '@oultook.com',
      '@outbook.com',
      '@otlook.com',
      '@outlok.com',
      '@htmail.com',
      '@hitmail.com',
      '@hotmail.con',
      '@gmaiil.com',
      '@gmil.com',
      '@gmai.com',
      '@g.mail.com',
      '@hotmial.com',
      '@gmaiul.com',
      '@hotmil.com',
      '@gamail.com',
      '@oulook.com',
      '@gemail.com',
      '@gmail.comm',
      '@gmail.es',
      '@hotmail.cm',
      '@HTMAIL.COM',
      '@hormail.com',
      '@hotmaill.com',
      '@yhoo.com',
      '@gmIl.com',
      '@gmaail.com',
      '@homai.com',
      '@hotrmail.com',
      '@terra.es',
      '@hootmail.es',
      '@iclound.com',
      '@yahho.es',
      '@homail.es',
    ].some((emailEnd) => emailEnd.endsWith(input));
  },
  { error: validations.email },
);

export const requiredStringSchema = z.string({ error: validations.string }).min(1, { error: validations.required });

// el primero (true) es para cuando validamos en el elemento, el segundo, stringbool es para cuando sacamos los valores del formData porque los checkboxes devuelven un valor "on"
export const privacySchema = z.union([z.literal(true, validations.privacy), z.stringbool(validations.privacy)]);

export function parseEmail(email: string) {
  return emailSchema.safeParse(email);
}
